/**
* Copyright by: 

* by ESS-Ehrhardt Software Solutions & Service GmbH
* Basselscheider Str. 55
* D-56281 Emmelshausen
* +49 (0) 67 42 / 87 27 0
* info@epg.com
*/
import { CommonModule } from '@angular/common';
import { Component, Input, OnChanges } from '@angular/core';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { faPenRuler } from '@fortawesome/pro-regular-svg-icons';

@Component({
  selector: 'app-workflow-badge',
  imports: [CommonModule, FaIconComponent],
  templateUrl: './workflow-badge.component.html',
  styleUrls: ['./workflow-badge.component.scss']
})
export class WorkflowStatusBadgeComponent implements OnChanges {
  @Input() isPublished = false;
  @Input() isDraft = false;

  publishedDraftIcon = faPenRuler;
  classLabel = '';
  displayLabel = '';

  ngOnChanges(): void {
    if (this.isPublished && this.isDraft) {
      this.classLabel = 'published-draft';
      this.displayLabel = $localize`:@@publishedDraft:Published, Draft available`;
    } else if (this.isPublished && !this.isDraft) {
      this.classLabel = 'published';
      this.displayLabel = $localize`:@@published:Published`;
    } else {
      this.classLabel = 'unpublished';
      this.displayLabel = $localize`:@@unpublished:Unpublished`;
    }
  }
}
